/**
 * Material-UI Theme Configuration
 * Admin Portal UnsOps theme
 *
 * Paleta de colores UnsOps:
 * - Primary: Azul/Índigo (#4F46E5)
 * - Secondary: Púrpura/Violeta (#A855F7)
 * - Gradiente: linear-gradient(135deg, #6366F1, #A855F7)
 */

import { createTheme } from '@mui/material/styles';

// UnsOps Brand Colors
export const unsopsColors = {
  primary: {
    main: '#4F46E5',
    light: '#6366F1',
    dark: '#4338CA',
    darker: '#312E81',
    lighter: '#F0F4FF',
  },
  secondary: {
    main: '#A855F7',
    light: '#C084FC',
    dark: '#9333EA',
    darker: '#7C3AED',
    lighter: '#FDF4FF',
  },
  gradient: 'linear-gradient(135deg, #6366F1, #A855F7)',
  gradientDark: 'linear-gradient(135deg, #4338CA, #7C3AED)',
};

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: unsopsColors.primary.main,
      light: unsopsColors.primary.light,
      dark: unsopsColors.primary.dark,
      contrastText: '#fff',
    },
    secondary: {
      main: unsopsColors.secondary.main,
      light: unsopsColors.secondary.light,
      dark: unsopsColors.secondary.dark,
      contrastText: '#fff',
    },
    error: {
      main: '#EF4444',
      light: '#F87171',
      dark: '#DC2626',
    },
    warning: {
      main: '#F59E0B',
      light: '#FBBF24',
      dark: '#D97706',
    },
    info: {
      main: '#3B82F6',
      light: '#60A5FA',
      dark: '#2563EB',
    },
    success: {
      main: '#22C55E',
      light: '#4ADE80',
      dark: '#16A34A',
    },
    background: {
      default: '#F8FAFC',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
        },
        containedPrimary: {
          background: unsopsColors.gradient,
          '&:hover': {
            background: unsopsColors.gradientDark,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(79, 70, 229, 0.08)',
          borderRadius: 12,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          backgroundColor: unsopsColors.primary.lighter,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          background: unsopsColors.gradient,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          background: unsopsColors.gradient,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none',
          boxShadow: '2px 0 12px rgba(79, 70, 229, 0.08)',
        },
      },
    },
  },
});
